import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import { isStringNullOrEmpty } from '../utils/validators'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { backgroundStyle } from '../styles/background'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import { useDispatch } from 'react-redux'

const ChangePassword = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const requestMaker = useRequests()
  const [previousPassword, setPreviousPassword] = useState('')
  const [password, setPassword] = useState('')
  const [passwordAgain, setPasswordAgain] = useState('')
  const [passwordError, setPasswordError] = useState<string | null>(null)
  const [passwordMatchError, setPasswordMatchError] = useState<string | null>(
    null
  )

  const handlePasswordsSubmit = async (): Promise<void> => {
    if (password !== passwordAgain) {
      setPasswordMatchError('Passwords should match')
      return
    }
    try {
      await requestMaker.changePassword(previousPassword, password)

      dispatch(
        RefreshActions.setToastMessage({ message: 'Password was changed' })
      )
      navigate('/profile')
    } catch (e) {
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Previous password is not correct'
        })
      )
      setPasswordError('Previous password is not correct')
    }
  }

  return (
    <>
      <form
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            void handlePasswordsSubmit()
          }
        }}
      >
        <Container component='main' maxWidth='xs'>
          <div style={backgroundStyle} />
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography component='h1' variant='h5'>
              Change password
            </Typography>
            <TextField
              error={!isStringNullOrEmpty(passwordError)}
              variant='filled'
              type='password'
              helperText={passwordError}
              value={previousPassword}
              onChange={e => setPreviousPassword(e.target.value)}
              margin='normal'
              required
              fullWidth
              name='previousPassword'
              label='Previous password'
              id='previousPassword'
              autoComplete='password'
            />
            <TextField
              variant='filled'
              type='password'
              value={password}
              onChange={e => setPassword(e.target.value)}
              margin='normal'
              required
              fullWidth
              name='password'
              label='New password'
              id='password'
            />
            <TextField
              error={!isStringNullOrEmpty(passwordMatchError)}
              id='password-again'
              label='New password again'
              variant='filled'
              helperText={passwordMatchError}
              type='password'
              value={passwordAgain}
              onChange={e => setPasswordAgain(e.target.value)}
              required
              fullWidth
              name='password'
            />
            <Button
              type='submit'
              fullWidth
              variant='contained'
              sx={{ mt: 3, mb: 2 }}
              disabled={password === '' || passwordAgain === ''}
              onClick={e => {
                e.preventDefault()
                void handlePasswordsSubmit()
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  void handlePasswordsSubmit()
                }
              }}
              tabIndex={0}
            >
              Sign In
            </Button>
          </Box>
        </Container>
      </form>
    </>
  )
}

export default ChangePassword
